import { Aviso } from "../ui";
import { useAvisosDoPainel, vigenciaLegivel } from "../../nucleo/avisos";
import { podeNaSessao, useSessao } from "../../nucleo/sessao";

/**
 * O mural no painel do cliente: os avisos da GEOvendas que valem para a empresa dele, até
 * expirarem. O servidor só manda o que está no ar e é dirigido à organização; a tela mostra o
 * que vier — e some sozinha quando não vem nada.
 */
export function AvisosDoPainel() {
  const sessao = useSessao();
  const pode = podeNaSessao(sessao.data, "aviso:ver");
  const avisos = useAvisosDoPainel(pode);

  if (!pode || !avisos.data || avisos.data.length === 0) return null;

  return (
    <section aria-labelledby="titulo-do-mural" className="mb-6" data-testid="mural-de-avisos">
      <h2 className="titulo-secao" id="titulo-do-mural">
        Avisos da GEOvendas
      </h2>
      {avisos.data.map((aviso) => (
        <Aviso key={aviso.id} tom="marca" className="mb-2" data-testid={`aviso-${aviso.id}`}>
          <b>{aviso.titulo}</b>
          {aviso.corpo.split("\n").map((linha, indice) => (
            <p key={indice} className="mt-1">
              {linha}
            </p>
          ))}
          <p className="nota-rodape mt-1">{vigenciaLegivel(aviso)}</p>
        </Aviso>
      ))}
    </section>
  );
}
